import type { FormKitNode } from "@formkit/core";

export const isFormKitNode = (node: unknown): node is FormKitNode => {
  return (node as FormKitNode).__FKNode__ === true;
};
